import http from "./httpService";
import axios from "axios";
import { weatherURL, mpURL } from "@/config";
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
// 用户相关
// 用户登录
export function login(params) {
  return http.post(`/user/login`, params);
}
// 用户注册
export function register(params) {
  return http.post(`/user/register`, params);
}
// 用户登出
export function logout(params = {}) {
  return http.post(`/user/logout`, params);
}
// 忘记密码
export function putForgetPassword(params) {
  return http.put(`/user/password/forget`, params);
}
// 获取区域列表
export function getRegionList(code) {
  return http.get(`/region/list/${code}`);
}
// // 用户注册
// export function getUserInfo(){
//   return http.get(`/user/info`)
// }
// 获取用户信息
export function getProfile() {
  return http.get(`/user/profile`);
}
// 验证码
export function postVCode(params) {
  return http.post(`/user/sendSMS`, params);
}

// 切换区域-获取区域列表
export function getRegionSwitchList() {
  return http.get(`/region/switch/list`);
}
// 切换区域-切换区域
export function putSwitchRegion(params) {
  return http.put(`/region/switch/to`, params);
}
// 获取当前区域
export function getSwitchRegion() {
  return http.get(`/region/switch/to`);
}
// 产品展示
export function getProductShow(params) {
  if (params[2]) {
    return http.get(`/product/show/${params[0]}/${params[1]}/${params[2]}`);
  } else {
    return http.get(`/product/show/${params[0]}/${params[1]}`);
  }
}

// 获取产品列表
export function getProductListUsable() {
  return http.get(`/product/list/usable`);
}
// 获取作物列表
export function getCropList() {
  return http.get(`/crop/list`);
}

// 获取农情调查列表
export function getAgriculturalList(params) {
  return http.get(`/crop/investigateList`, { params });
}
// 获取农情调查列表详情页
export function getCropdetails(investigate_id) {
  return http.get(`/crop/investigate/${investigate_id}`);
}
// 获取农情调查图片打包下载
export function downloadInvestigate(ids) {
  return http.post(`/crop/downloadInvestigate`, ids, {
    responseType: "blob"
  });
}
// 产品展示新
export function getProductByCategory(params) {
  return http.get(`/product/${params[0]}/${params[1]}`);
}

export function getProductPdf(id) {
  return http.get(`/product/${id}`, {
    cancelToken: source.token
  });
}
// 区域规划
export function getClimateList(type) {
  return http.get(`/climate/list/${type}`);
}
// 生产百科
export function getPediaList(type) {
  return http.get(`/pedia/list/${type}`);
}
// 生产百科搜索功能
export function postPediaList(params) {
  return http.post(`/pedia/search`, params);
}
// 政策要闻
export function getNewsList() {
  return http.get(`/news/list`);
}
// 政策要闻跟多
export function getNewsListMore() {
  return http.get(`/news/list/more`);
}
// 政策要闻详情
export function getNews(id) {
  return http.get(`/news/${id}`);
}
// 政策轮播图列表
export function getSwiperList(id) {
  return http.get(`/swiper/list`);
}
// 价格分类
export function getPriceCategey() {
  return axios.get(`/static/json/price_items.json`);
}
//近期价格行情
export function getNearPrice(params) {
  return http.get(`/price/by/near`, { params });
}
// 价格行情
export function getPriceByDate(date) {
  return http.get(`/price/by/date/${date}`);
}
// 价格行情
export function getPriceByPeriod(data, params) {
  return http.get(`/price/by/period/${data.product}`, { params });
  // return http.get(`/price/by/period/${data.market}/${data.product}`)
}
// 设施小气候站点list
export function getMonitorStationList(data) {
  return http.get(`/monitor/station/list`);
}
// 设施小气候站点气象数据
export function getMonitorData(station_id) {
  return http.get(`/monitor/data/${station_id}`);
}
// 设施小气候站点气象数据趋势图
export function getMonitorDataPeriod(station_id, period) {
  return http.get(`/monitor/data/${station_id}/${period[0]}/${period[1]}`);
}
// 设施小气候检测list
export function getMonitorDirList(data) {
  return http.get(`/monitor/dir/list`);
}
// 设施小气候检测区域切换
export function getMonitor(dir_str) {
  return http.get(`/monitor/${dir_str}`);
}
// 设施小气候检测区域图片
export function getMonitorPic(dir_str, dir_date) {
  return http.get(`/monitor/pic/${dir_str}/${dir_date}`);
}
// 首页七天预报
export function getMeteo7days(lonlat) {
  return http.get(`/weather/forecast/day/${lonlat.lon}/${lonlat.lat}/7`, {
    baseURL: weatherURL
  });
}
// 首页切换站点列表
export function getMeteoStationList() {
  return http.get(`/meteo/station/list`);
}
// 首页站点当前数据
export function getMeteoDataNow(lonlat) {
  return http.get(`/weather/real_time/${lonlat.lon}/${lonlat.lat}`, {
    baseURL: weatherURL
  });
}
// 首页站点数据监测

export function getMeteoDataByLocation(lonlat) {
  return http.get(`/weather/forecast/hour/${lonlat.lon}/${lonlat.lat}`, {
    baseURL: weatherURL
  });
}
// 获取逐小时预报数据
export function getWFHByLocation(lonlat) {
  return http.get(`/weather/forecast/hour/${lonlat.lon}/${lonlat.lat}`, {
    baseURL: weatherURL
  });
}
export function getMeteoDataLast(station, hour) {
  return http.get(`/meteo/${station}/last/${hour}`);
}
// 首页地图数据
export function getMeteoMapAll() {
  return http.get(`/meteo/map/all`);
}
//按日期获取tif数据
export function getGridTif(params) {
  return http.get(
    `/grid/${params.kind}/${params.time}/${params.type}/${params.factor}/${
      params.key
    }`
  );
}
// 获取最临近tif数据
export function getGridNearTif(params) {
  return http.get(
    `/grid/${params.kind}/${params.type}/${params.factor}/${params.key}`
  );
}
// 首页地图预警
export function getAlarmWarning(params) {
  //news、map/all
  return http.get(`/alarm/getAlarm`, { params, baseURL: weatherURL });
}
export function getTownMapData() {
  return axios.get(`/static/json/town.json`);
}
export function getCityMapData() {
  return axios.get(`/static/json/city.json`);
}
//天气预警信息
export function getWarningInfo() {
  return http.get(`/weather/weatherInfo.json`, { baseURL: mpURL });
}
// 获取当前定位数据信息
export function getCurrentLocation(params) {
  return http.get(
    `/region/position/${params.lat.toFixed(2)}/${params.lon.toFixed(2)}`
  );
}



// WEBPACK FOOTER //
// ./src/api/http.js